import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'agendario:finance:recentItems';
const MAX_ITEMS = 5;

function read() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
  catch { return []; }
}

export function useRecentFinanceItems() {
  const [items, setItems] = useState(read);

  useEffect(() => {
    const onStorage = (e) => { if (e.key === STORAGE_KEY) setItems(read()); };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const push = useCallback((item) => {
    const entry = {
      type: item.type,
      description: item.description,
      value: item.value,
      valueType: item.valueType,
    };
    const key = JSON.stringify(entry);
    const next = [entry, ...read().filter((x) => JSON.stringify(x) !== key)].slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    setItems(next);
  }, []);

  return { items, push };
}
